import { Typography, Paper, Box, useTheme, Stack } from "@mui/material"
import { useNavigate } from "react-router-dom"
import React, { useMemo, useState, useEffect, useRef } from "react"
import ButtonWithIcon from "src/v2/components/Button/Button"
import { ReactComponent as CalcIcon } from "src/v2/assets/icons/calc-icon.svg"
import { ReactComponent as CheckIcon } from "src/v2/assets/icons/check-icon.svg"
import { ReactComponent as EditIcon } from "src/v2/assets/icons/lock-empty-icon.svg"
import CaracteristicasSection from "./CaracteristicasSection"
import DatasSection from "./DatasSection"
import JurosCorrecaoSection from "./JurosCorrecaoSection"
import FatorArredondamentoSection from "./FatorArredondamentoSection"
import FormActions from "../../components/FormActions"
import DuplaConfirmacao from "../../../../components/DuplaConfirmacao/DuplaConfirmacao"
import { caracteristicasFields } from "./CaracteristicasSection/constants"
import { datasFields } from "./DatasSection/constants"
import { jurosCorrecaoFields } from "./JurosCorrecaoSection/constants"
import { fatorArredondamentoFields } from "./FatorArredondamentoSection/constants"
import { caracteristicasSectionKeys } from "./CaracteristicasSection/section-keys"
import { datasSectionKeys } from "./DatasSection/section-keys"
import { jurosCorrecaoSectionKeys } from "./JurosCorrecaoSection/section-keys"
import { fatorArredondamentoSectionKeys } from "./FatorArredondamentoSection/section-keys"
import { getInvalidFields } from "../../utils/section-validity"
import { dispatchSnackbar } from "src/v2/components/SnackBar/snackbar-bus"
import MotorParametrosService from "src/services/motor-parametros-service"
import MotorDataAniversarioService from "src/services/motor-data-aniversario-service"
import {
    mapCadastroTemporarioParametros,
    mapCaracteristicaParametros,
    mapParametrosToForm,
    calcularDatasDerivadas,
    calcularCamposDerivados
} from "../../utils/map-temporary-cadastro"
import {
    useGrupoAtivosCorporateIFAutocompleteController
} from "../../hooks/useGrupoAtivosCorporateIFAutocompleteController"
import PropTypes from "prop-types"
import MotorRecompraProgramadaService from "../../../../../services/motor-recompra-programada-service"
import {
    mapRecompraProgramadaProjetarPayload
} from "../EventosOrdinarios/components/recompra-programada/recompra-programada-fields"
import { useDraftLoadGuard } from "../use-draft-load-guard"

const sectionScrollMargin = 20

const ParametrosPage = (
    {
        setLoading,
        idCaracteristica,
        loading,
        producao,
        setProducao,
        caracteristica,
        eventosState,
        projetarEventos,
        jurosOptions,
        onDraftChange,
        onDraftEdit,
    }) => {
    const navigate = useNavigate()
    const parametrosService = new MotorParametrosService()
    const dataAniversarioService = useMemo(() => new MotorDataAniversarioService(), [])
    const recompraProgramadaService = new MotorRecompraProgramadaService()
    const theme = useTheme()
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)
    const [publishConfirmOpen, setPublishConfirmOpen] = useState(false)
    const [editarCetipOpen, setEditarCetipOpen] = useState(false)
    const [grupoAtivosReloadKey] = useState(0)
    const grupoAtivosAutoCompleteController = useGrupoAtivosCorporateIFAutocompleteController(grupoAtivosReloadKey)
    const autoCompleteController = useMemo(() => ({ grupoAtivos: grupoAtivosAutoCompleteController, }), [grupoAtivosAutoCompleteController])
    const [pendingParametro, setPendingParametro] = useState(null)
    const [indexadoresDataAniversario, setIndexadoresDataAniversario] = useState([])
    const [indexadoresDataAniversarioCarregados, setIndexadoresDataAniversarioCarregados] = useState(false)
    const userEditsRef = useRef([])

    const fieldsMap = {
        caracteristicas: caracteristicasFields,
        datas: datasFields,
        jurosCorrecao: jurosCorrecaoFields(jurosOptions),
        fatorArredondamento: fatorArredondamentoFields
    }

    const handleEditarCetipClick = (e) => {
        e?.preventDefault()
        e?.stopPropagation()
        setEditarCetipOpen(true)
    }

    const handleConfirmEditarCetip = () => {
        setEditarCetipOpen(false)
        handlePublish()
    }

    const handleCancelEditarCetip = () => {
        setEditarCetipOpen(false)
    }

    const generateInitialState = (fields) => {
        return fields.reduce((acc, field) => {
            acc[field.key] = field.defaultValue ?? ""
            return acc
        }, {})
    }

    const DEFAULT_PARAMETROS = {
        caracteristicas: generateInitialState(caracteristicasFields),
        datas: {
            ...generateInitialState(datasFields),
            dataRentabilidadeInicioManual: false,
            dataRentabilidadeFimManual: false,
            dataInicioPagamentoAmortizacaoManual: false,
            dataInicioPagamentoJurosManual: false,
        },
        jurosCorrecao: generateInitialState(jurosCorrecaoFields(jurosOptions)),
        fatorArredondamento: generateInitialState(fatorArredondamentoFields)
    }
    const [formData, setFormData] = useState(DEFAULT_PARAMETROS)

    const { beginDraftLoad } = useDraftLoadGuard(
        `${idCaracteristica}:${eventosState?.VersaoDocumento}`,
        null,
    )

    useEffect(() => {
        const loadIndexadoresDataAniversario = async () => {
            try {
                const response =
                    await dataAniversarioService.getIndicadoresDataAniversario()

                const body = response?.body ?? response?.data ?? []

                const indexadores = Array.isArray(body)
                    ? body
                    : body?.results ?? []

                setIndexadoresDataAniversario(indexadores)
            } catch (error) {
                console.error(
                    "Erro ao carregar indexadores de Data Aniversário:",
                    error
                )

                setIndexadoresDataAniversario([])

                dispatchSnackbar(
                    "Não foi possível carregar os indexadores de Data Aniversário.",
                    "warning"
                )
            } finally {
                setIndexadoresDataAniversarioCarregados(true)
            }
        }

        loadIndexadoresDataAniversario()
    }, [dataAniversarioService])

    const normalizarIndexador = (valor) => {
        return String(valor || "")
            .trim()
            .toUpperCase()
    }

    const indexadoresDataAniversarioSet = useMemo(() => {
        return new Set(
            indexadoresDataAniversario.map(normalizarIndexador)
        )
    }, [indexadoresDataAniversario])

    const obterDiaData = (valor) => {
        if (!valor) return null

        const data = String(valor).trim()

        const formatoIso = data.match(/^\d{4}-\d{2}-(\d{2})/)
        if (formatoIso) {
            return Number(formatoIso[1])
        }

        const formatoBr = data.match(/^(\d{2})\/\d{2}\/\d{4}$/)
        if (formatoBr) {
            return Number(formatoBr[1])
        }

        return null
    }

    useEffect(() => {
        userEditsRef.current = []
    }, [idCaracteristica])

    const applySectionField = (prev, section, key, value) => {
        const nextSection = {
            ...prev[section],
            [key]: value,
        }

        if (section === "datas") {
            if (key === "dataRentabilidadeInicio") {
                nextSection.dataRentabilidadeInicioManual = true
            }

            if (key === "dataRentabilidadeFim") {
                nextSection.dataRentabilidadeFimManual = true
            }

            if (key === "dataInicioPagamentoAmortizacao") {
                nextSection.dataInicioPagamentoAmortizacaoManual = true
            }

            if (key === "dataInicioPagamentoJuros") {
                nextSection.dataInicioPagamentoJurosManual = true
            }

            if (key === "dataIntegralizacao" && !prev.datas.dataRentabilidadeInicioManual) {
                nextSection.dataRentabilidadeInicio = value
            }

            if (key === "dataVencimento") {
                if (!prev.datas.dataRentabilidadeFimManual) {
                    nextSection.dataRentabilidadeFim = value
                }

                if (prev.datas.frequenciaJuros === 0 && !prev.datas.dataInicioPagamentoJurosManual) {
                    nextSection.dataInicioPagamentoJuros = value
                }

                if (prev.datas.frequenciaAmortizacao === 0 && !prev.datas.dataInicioPagamentoAmortizacaoManual) {
                    nextSection.dataInicioPagamentoAmortizacao = value
                }
            }

            if (key === "frequenciaJuros" && value === 0 && !prev.datas.dataInicioPagamentoJurosManual) {
                nextSection.dataInicioPagamentoJuros = prev.datas.dataVencimento
            }

            if (key === "frequenciaAmortizacao" && value === 0 && !prev.datas.dataInicioPagamentoAmortizacaoManual) {
                nextSection.dataInicioPagamentoAmortizacao = prev.datas.dataVencimento
            }
        }

        if (section === "jurosCorrecao") {
            if (key === "formulaIndexador") {
                const selected = jurosOptions.find(item => item.IDJuros === value)
                nextSection.calculoDiasIndexador = selected?.CalculoDias ?? null
            }

            if (key === "jurosCapitalizacao") {
                const selected = jurosOptions.find(item => item.IDJuros === value)
                nextSection.calculoDias = selected?.CalculoDias ?? null
            }

            if (key === "tipoCorrecao") {
                nextSection.diaAniversario =
                    value === "Padrão"
                        ? nextSection.diaAniversario || obterDiaData(prev.datas.dataEmissao)
                        : null
            }
        }

        return {
            ...prev,
            [section]: nextSection,
        }
    }

    const setSectionField = (section, key, value) => {
        userEditsRef.current.push({ section, key, value })
        onDraftEdit?.()
        setFormData((prev) => applySectionField(prev, section, key, value))
    }

    const exibirCamposDataAniversario =
        indexadoresDataAniversarioCarregados &&
        indexadoresDataAniversarioSet.has(
            normalizarIndexador(
                formData.caracteristicas.indexador
            )
        )

    useEffect(() => {
        const caracteristicaBase = caracteristica?.Caracteristica ?? caracteristica ?? {}

        onDraftChange?.({
            caracteristica: {
                cetip: caracteristicaBase.CETIP,
                versaoDocumento: caracteristicaBase.VersaoDocumento,
                tipoAtivo: caracteristicaBase.TipoAtivo,
                indexador: caracteristicaBase.Indexador,
                incentivada: caracteristicaBase.Incentivada,
                spreadEmissao: caracteristicaBase.SpreadEmissao,
                idEmissao: caracteristicaBase.IDEmissao,
                dataReferencia: caracteristicaBase.DataReferencia,
                puEmissao: caracteristicaBase.PUEmissao,
                ...formData.caracteristicas,
                dataEmissao: formData.datas.dataEmissao,
                dataVencimento: formData.datas.dataVencimento,
            },
            parametros: formData,
        })
    }, [caracteristica, formData, onDraftChange])

    useEffect(() => {
        if (!indexadoresDataAniversarioCarregados) return
        if (!exibirCamposDataAniversario) return

        setFormData(prev => {
            const jurosCorrecao = prev.jurosCorrecao

            const corrigeDataAniversario =
                jurosCorrecao.corrigeDataAniversario ??
                "Não Corrige"

            const tipoCorrecao =
                jurosCorrecao.tipoCorrecao ??
                "Vencimento"

            if (
                corrigeDataAniversario ===
                jurosCorrecao.corrigeDataAniversario &&
                tipoCorrecao ===
                jurosCorrecao.tipoCorrecao
            ) {
                return prev
            }

            return {
                ...prev,
                jurosCorrecao: {
                    ...jurosCorrecao,
                    corrigeDataAniversario,
                    tipoCorrecao,
                },
            }
        })
    }, [
        indexadoresDataAniversarioCarregados,
        exibirCamposDataAniversario,
    ])

    useEffect(() => {
        if (!indexadoresDataAniversarioCarregados) return
        if (exibirCamposDataAniversario) return

        setFormData(prev => ({
            ...prev,
            jurosCorrecao: {
                ...prev.jurosCorrecao,
                corrigeDataAniversario: null,
                tipoCorrecao: null,
                diaAniversario: null,
            },
        }))
    }, [
        indexadoresDataAniversarioCarregados,
        exibirCamposDataAniversario,
    ])

    const validateForm = () => {
        const invalidFields = [
            ...getInvalidFields({
                sectionName: "caracteristicas",
                keys: caracteristicasSectionKeys,
                state: formData.caracteristicas,
                fieldsMap
            }),
            ...getInvalidFields({ sectionName: "datas", keys: datasSectionKeys, state: formData.datas, fieldsMap }),
            ...getInvalidFields({
                sectionName: "jurosCorrecao",
                keys: jurosCorrecaoSectionKeys,
                state: formData.jurosCorrecao,
                fieldsMap
            }),
            ...getInvalidFields({
                sectionName: "fatorArredondamento",
                keys: fatorArredondamentoSectionKeys,
                state: formData.fatorArredondamento,
                fieldsMap
            }),
        ]


        if (invalidFields.length > 0) {
            dispatchSnackbar(`Campos obrigatórios não preenchidos: ${invalidFields.join(", ")}`, "warning")
            return false
        }

        if (exibirCamposDataAniversario && formData.jurosCorrecao.tipoCorrecao === "Padrão") {
            const diaAniversario = Number(formData.jurosCorrecao.diaAniversario)

            if (!Number.isInteger(diaAniversario) || diaAniversario < 1 || diaAniversario > 31) {
                dispatchSnackbar(
                    "O Dia Aniversário deve ser informado com um valor entre 1 e 31.",
                    "warning"
                )
                return false
            }
        }

        return true
    }

    const buildCaracteristica = async (Caracteristica) => {

        if (Caracteristica) {
            const { CETIP, VersaoDocumento } = Caracteristica
            const caracteristicaMapeada = mapCaracteristicaParametros(Caracteristica)

            const {
                dataEmissao,
                dataIntegralizacao,
                dataVencimento,
                frequenciaJuros,
                frequenciaAmortizacao,
                ...caracteristicasRest
            } = caracteristicaMapeada

            const camposDerivados = calcularCamposDerivados(Caracteristica)

            setFormData(prev => ({
                ...prev,
                caracteristicas: {
                    ...prev.caracteristicas,
                    ...caracteristicasRest,
                    cetip: CETIP ?? "",
                    versaoDocumento: VersaoDocumento ?? "",
                    taxaJuros: camposDerivados.taxaJuros,
                },
                datas: {
                    ...prev.datas,
                    dataEmissao,
                    dataIntegralizacao,
                    dataVencimento,

                    dataRentabilidadeInicio: prev.datas.dataRentabilidadeInicioManual
                        ? prev.datas.dataRentabilidadeInicio
                        : dataIntegralizacao,

                    dataRentabilidadeFim: prev.datas.dataRentabilidadeFimManual
                        ? prev.datas.dataRentabilidadeFim
                        : dataVencimento,

                    frequenciaJuros,
                    frequenciaAmortizacao,
                    ...calcularDatasDerivadas(Caracteristica)
                },
                jurosCorrecao: {
                    ...prev.jurosCorrecao,
                    indexadorCorrecaoPercentual: camposDerivados.indexadorCorrecaoPercentual,
                }
            }))
        }
    }

    const buildParametros = (parametro) => {
        if (!parametro) return

        if (!jurosOptions?.length) {
            setPendingParametro({
                valor: parametro,
                idCaracteristica,
            })
            return
        }

        const parametroMapeado = mapParametrosToForm(parametro, jurosOptions, caracteristica)

        const edits = [...userEditsRef.current]
        setFormData(prev => {
            const loaded = {
                ...prev,
                caracteristicas: { ...prev.caracteristicas, ...parametroMapeado.caracteristicas },
                datas: { ...prev.datas, ...parametroMapeado.datas },
                jurosCorrecao: { ...prev.jurosCorrecao, ...parametroMapeado.jurosCorrecao },
                fatorArredondamento: { ...prev.fatorArredondamento, ...parametroMapeado.fatorArredondamento }
            }
            return edits.reduce(
                (current, { section, key, value }) => applySectionField(current, section, key, value),
                loaded,
            )
        })
    }

    useEffect(() => {
        if (!pendingParametro || !jurosOptions?.length) return

        if (pendingParametro.idCaracteristica === idCaracteristica) {
            buildParametros(pendingParametro.valor)
        }
        setPendingParametro(null)
    }, [pendingParametro, jurosOptions, idCaracteristica])

    useEffect(() => {
        const { origem, Data } = eventosState
        if (origem === "novo") {
            buildCaracteristica(Data)
        }
    }, [])

    useEffect(() => {
        const { origem } = eventosState
        if (origem === "duplicar") {
            const { Data } = eventosState
            const { Parametros, Caracteristica, CETIP, VersaoDocumento } = Data

            if (Parametros !== null) {
                let parametros = Parametros
                const { Caracteristica: { IDEmissao } } = Caracteristica
                parametros.CETIP = CETIP
                parametros.VersaoDocumento = VersaoDocumento
                parametros.IDEmissao = IDEmissao
                buildParametros(parametros)
            } else {
                let caracteristica = Caracteristica.Caracteristica
                caracteristica.CETIP = CETIP
                caracteristica.VersaoDocumento = VersaoDocumento
                buildCaracteristica(caracteristica)
            }
        }
    }, [eventosState])

    useEffect(() => {
        const { origem } = eventosState
        if (origem === "ver") {
            if (!caracteristica) return

            const { Parametros } = eventosState
            if (Parametros == null) {
                let { Caracteristica, CETIP, VersaoDocumento } = caracteristica

                Caracteristica.CETIP = CETIP
                Caracteristica.VersaoDocumento = VersaoDocumento
                buildCaracteristica(Caracteristica)
                return
            }
            loadParametros(idCaracteristica, beginDraftLoad())
        }

    }, [caracteristica, idCaracteristica, beginDraftLoad])

    const loadParametros = async (idCaracteristica, guard) => {
        try {
            setLoading(true)
            const { Data } = eventosState
            const { Parametros } = Data
            if (Parametros === null) return

            if (Parametros.Status === "Em Andamento") {
                const response = await parametrosService.getCadastroTemporarioParametros(idCaracteristica)
                if (!guard.isCurrent()) return
                const { body } = response
                buildParametros(body)
                return
            }

            if (Parametros.Status === "Em Produção") {
                const response = await parametrosService.getCadastroParametros(idCaracteristica)
                if (!guard.isCurrent()) return
                const { body } = response
                setProducao(true)
                buildParametros(body)
                return
            }
            console.log("não é nem andamento nem producao")
            const { Caracteristica } = caracteristica
            buildCaracteristica(Caracteristica)
        } catch (error) {
            if (guard.isCurrent()) dispatchSnackbar("Não foi possível carregar os parâmetros", "warning")
        } finally {
            if (guard.isCurrent()) setLoading(false)
        }
    }

    const handleSave = async () => {
        if (!validateForm()) return
        try {
            setLoading(true)

            const payload = mapCadastroTemporarioParametros(formData, exibirCamposDataAniversario)
            if (!idCaracteristica) {
                dispatchSnackbar(
                    "Não existe cadastro de características para o CETIP e versão informados.",
                    "error"
                )
                return
            }

            const saveResponse =
                await parametrosService.createCadastroTemporarioParametros(
                    idCaracteristica,
                    payload
                )

            const mensagem = saveResponse?.body?.mensagem ?? "Parâmetros salvos com sucesso."
            dispatchSnackbar(mensagem, "success")
        } catch (error) {
            const { response: { text } } = error
            const errorMessage = text || "Erro ao salvar parâmetros."
            dispatchSnackbar(errorMessage, "error")
        } finally {
            setLoading(false)
        }
    }

    const handlePublish = async () => {
        if (!validateForm()) return
        try {
            setLoading(true)
            const payload = mapCadastroTemporarioParametros(formData, exibirCamposDataAniversario)
            producao
                ? await parametrosService.updateCadastroParametros(idCaracteristica, payload)
                : await parametrosService.createCadastroParametros(idCaracteristica, payload)

            setProducao(true)
            dispatchSnackbar(
                producao
                    ? "Cadastro atualizado em produção com sucesso."
                    : "Cadastro publicado com sucesso.",
                "success"
            )
        } catch (error) {
            console.error("Erro ao publicar cadastro", error)
            const { response: { text } } = error
            const errorMessage = text || "Erro ao publicar parâmetros."
            dispatchSnackbar(errorMessage, "error")
        } finally {
            setLoading(false)
            setPublishConfirmOpen(false)
        }
    }

    const handleDelete = async () => {
        try {
            setLoading(true)

            if (!idCaracteristica) {
                return
            }

            producao ?
                await parametrosService.deleteCadastroParametros(idCaracteristica) :
                await parametrosService.deleteCadastroTemporarioParametros(idCaracteristica)

            dispatchSnackbar(producao
                ? "Cadastro deletado com sucesso."
                : "Cadastro temporário deletado com sucesso.",
                "success")

            setProducao(false)
            userEditsRef.current = []
            setFormData(DEFAULT_PARAMETROS)
            onDraftEdit?.()
        } catch (error) {
            console.error("Erro ao deletar cadastro", error)
            const { response: { text } } = error
            const errorMessage = text || "Erro ao deletar parâmetros."
            dispatchSnackbar(errorMessage, "error")
        } finally {
            setLoading(false)
            setDeleteConfirmOpen(false)
        }
    }

    const geraProjecaoEventos = () => {
        if (!validateForm()) return

        let payload = mapCadastroTemporarioParametros(formData, exibirCamposDataAniversario)

        const {
            CETIP,
            VersaoDocumento,
            Caracteristica: { IDEmissao, Perpetuidade },
        } = caracteristica

        const payloadEventos = { ...payload, CETIP, VersaoDocumento, IDEmissao, }
        const payloadRecompra = mapRecompraProgramadaProjetarPayload(IDEmissao, CETIP, VersaoDocumento, idCaracteristica, Perpetuidade, payload)

        setLoading(true)

        Promise.all([
            parametrosService.geraProjecaoEventos(payloadEventos),
            recompraProgramadaService.geraProjecaoRecompraProgramada(payloadRecompra),
        ])
            .then(([eventosResponse, recompraResponse]) => {
                const eventosOrdinarios = eventosResponse?.body?.Eventos ?? []
                const datasAniversario = eventosResponse?.body?.DatasAniversario ?? []
                const eventosRecompra = recompraResponse?.body?.Eventos ?? []
                const mensagemRecompra = recompraResponse?.body?.Mensagem

                projetarEventos(eventosOrdinarios, datasAniversario, eventosRecompra)

                if (mensagemRecompra) {
                    dispatchSnackbar(mensagemRecompra, "warning")
                }
            })
            .catch((err) => {
                const body = err?.response?.body ?? "Erro ao gerar projeções"
                dispatchSnackbar(
                    typeof body === "string" ? body : JSON.stringify(body),
                    "error"
                )
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <>
            <Paper sx={{ pt: 3, pb: 2, pl: 4, pr: 4, mb: 2 }}>
                <Typography
                    sx={{
                        fontWeight: 400,
                        fontSize: "14px",
                        textTransform: "uppercase",
                        color: "white.main"
                    }}
                >
                    Projetar
                </Typography>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 2
                    }}
                >
                    <Typography sx={{ color: 'white.main', maxWidth: '70%' }}>
                        <p>
                            Com base nos Parâmetros abaixo, gostaria que o sistema projete o fluxo dos Eventos
                            Ordinários.
                        </p>
                        <p>
                            <strong>Importante:</strong> Lembre-se de salvar e publicar os
                            dados <strong>antes</strong> de clicar no botão “Projetar”.
                        </p>
                        <p>
                            Caso contrário, as alterações feitas nos parâmetros serão perdidas.
                        </p>
                    </Typography>

                    <Box>
                        <ButtonWithIcon icon={<CalcIcon />} onClick={geraProjecaoEventos} size="md">
                            PROJETAR
                        </ButtonWithIcon>
                    </Box>
                </Box>
            </Paper>

            <Stack spacing={2} sx={{ mb: 4 }}>
                <Box data-section="caracteristicas" sx={{ scrollMarginTop: sectionScrollMargin }}>
                    <CaracteristicasSection
                        state={formData.caracteristicas}
                        setSectionField={setSectionField}
                        defaultOpen
                        autoCompleteController={autoCompleteController}
                    />
                </Box>

                <Box data-section="datas" style={{ scrollMarginTop: sectionScrollMargin }}>
                    <DatasSection
                        state={formData.datas}
                        setSectionField={setSectionField}
                    />
                </Box>

                <Box data-section="jurosCorrecao" style={{ scrollMarginTop: sectionScrollMargin }}>
                    <JurosCorrecaoSection
                        state={formData.jurosCorrecao}
                        setSectionField={setSectionField}
                        jurosOptions={jurosOptions}
                        autoCompleteController={autoCompleteController}
                        exibirCamposDataAniversario={exibirCamposDataAniversario}
                    />
                </Box>

                <Box data-section="fatorArredondamento" style={{ scrollMarginTop: sectionScrollMargin }}>
                    <FatorArredondamentoSection
                        state={formData.fatorArredondamento}
                        setSectionField={setSectionField}
                    />
                </Box>
            </Stack>

            <br />
            <Box sx={{ pt: 1, mt: 2 }}>
                <FormActions
                    showBack
                    onBack={() => navigate(-1)}
                    onDelete={() => setDeleteConfirmOpen(true)}
                    deleteOpen={deleteConfirmOpen}
                    setDeleteOpen={setDeleteConfirmOpen}
                    onConfirmDelete={handleDelete}
                    showSave={!producao}
                    onSave={!loading ? handleSave : undefined}
                    onPublish={producao ? handleEditarCetipClick : () => setPublishConfirmOpen(true)}
                    publishOpen={publishConfirmOpen}
                    setPublishOpen={setPublishConfirmOpen}
                    onConfirmPublish={handlePublish}
                    publishLabel={producao ? "EDITAR" : "PUBLICAR"}
                    publishIcon={producao ? <EditIcon /> : <CheckIcon />}
                    theme={theme}
                />
            </Box>

            <DuplaConfirmacao
                open={editarCetipOpen}
                cancel={handleCancelEditarCetip}
                confirm={handleConfirmEditarCetip}
                title="Editar"
                description="Certifique-se de que todas as alterações necessárias foram feitas, já que este é um registro em produção."
            />
        </>
    )
}

ParametrosPage.propTypes = {
    idCaracteristica: PropTypes.number,
    caracteristica: PropTypes.object.isRequired,
    setLoading: PropTypes.func,
    loading: PropTypes.bool,
    status: PropTypes.string,
    producao: PropTypes.bool,
    jurosOptions: PropTypes.array,
    setProducao: PropTypes.func,
    eventosState: PropTypes.object,
    projetarEventos: PropTypes.func,
    onDraftChange: PropTypes.func,
    onDraftEdit: PropTypes.func,
}

export default ParametrosPage
